import { useMemo } from 'react';

import type { CustomRowSetting, MenuRowRules } from '@jane/shared/util';
import {
  createWeightFilterFromRules,
  getMenuRowWeightFilter,
} from '@jane/shared/util';

interface UseMenuRowWeightFilterOptions {
  customRowSettings?: readonly CustomRowSetting[];
  menuRowRules?: MenuRowRules;
  rowId?: number;
  rowTitle?: string;
}

/**
 * Hook to create a weight filter function for menu rows with price thresholds.
 * Filters out weights that don't meet minimum_price or maximum_price criteria.
 */
export function useMenuRowWeightFilter({
  customRowSettings,
  menuRowRules,
  rowId,
  rowTitle,
}: UseMenuRowWeightFilterOptions = {}) {
  return useMemo(() => {
    if (menuRowRules) {
      return createWeightFilterFromRules(menuRowRules);
    }

    if (customRowSettings) {
      return getMenuRowWeightFilter({ customRowSettings, rowId, rowTitle });
    }

    return undefined;
  }, [customRowSettings, menuRowRules, rowId, rowTitle]);
}
